/* Paintly Kits: Why Paintly Kits stands out, C1 Live layout (approved 5 Oct 2026). Built by build_theme.py from the
   Round 6 prototype (wps6.js). The reel shows two videos side by side on a phone, three on a computer (a set). When it
   is well in view the set plays from the start; 5 seconds after the first video starts playing, the row slides on to
   the next set, and after the last back to the first. A swipe moves it by hand (only a hand swipe restarts the
   5 seconds; a swipe that lands while the row is moving plays the set in view). Videos start loading about a screen
   away and pause when scrolled away. The numbers count up and their rings fill when they come into view.
   Reduced motion: nothing plays or slides by itself; the numbers show finished; tap a video to play or pause it. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window, HOLD = 5000;
  function load(v) {
    if (v._pk) return; v._pk = 1;
    [].forEach.call(v.querySelectorAll('source[data-src]'), function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
    v.preload = 'auto'; v.load();
  }
  function go(v) { load(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function boot(sec) {
    if (!sec || sec.getAttribute('data-pkws')) return; sec.setAttribute('data-pkws', '1');
    var reel = sec.querySelector('.pkws-reel'); if (!reel) return;
    var cards = [].slice.call(reel.querySelectorAll('.pkws-card')); if (!cards.length) return;
    var vids = cards.map(function (c) { return c.querySelector('video'); });
    var per = 2, pages = 1, cur = 0, inView = false, timer = 0, auto = false, settle = 0, touched = false, tok = 0, downAt = 0, lastScroll = 0;
    if (IO) new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { vids.forEach(load); o.disconnect(); } }); }, { rootMargin: '900px 0px' }).observe(sec);
    else vids.forEach(load);
    function offset(i) { return i ? Math.min(cards[i * per].offsetLeft - cards[0].offsetLeft, reel.scrollWidth - reel.clientWidth) : 0; }
    function groupVids(i) { return vids.slice(i * per, i * per + per); }
    function measure() { per = Math.max(1, Math.round((reel.clientWidth + 12) / (cards[0].offsetWidth + 12))); pages = Math.ceil(cards.length / per); if (cur >= pages) cur = 0; }
    function stopAll(except) { vids.forEach(function (v) { if (except.indexOf(v) < 0 && !v.paused) v.pause(); }); }
    function startSet(restart) {
      clearTimeout(timer); timer = 0; var t = ++tok;
      var vs = groupVids(cur); stopAll(vs);
      if (reduce || !inView) return;
      vs.forEach(function (v) { if (restart) { try { v.currentTime = 0; } catch (e) {} } go(v); });
      // count the 5 seconds from when the first video is actually playing
      var lead = vs[0], start = function () { if (t !== tok || !inView) return; clearTimeout(timer); timer = setTimeout(function () { show(cur + 1); }, HOLD); };
      if (!lead.paused && lead.readyState > 2) start(); else lead.addEventListener('playing', start, { once: true });
    }
    function at() { return Math.max(0, Math.min(pages - 1, Math.round(reel.scrollLeft / Math.max(1, offset(1))))); }
    function align() {
      var o = offset(cur); if (Math.abs(reel.scrollLeft - o) < 4) return;
      auto = true; reel.scrollTo({ left: o, behavior: reduce ? 'auto' : 'smooth' });
      clearTimeout(settle); settle = setTimeout(function () { auto = false; }, 700);
    }
    // after an automatic change: if a swipe landed on another set while the row was moving, play the set in view
    function reconcile() { var i = at(); if (i !== cur && Math.abs(reel.scrollLeft - offset(cur)) > 24) { cur = i; startSet(true); } align(); }
    function show(i) {
      var from = cur; cur = ((i % pages) + pages) % pages; if (cur === from) return;
      auto = true; clearTimeout(settle);
      reel.scrollTo({ left: offset(cur), behavior: reduce ? 'auto' : 'smooth' }); startSet(true);
      settle = setTimeout(function () { auto = false; reconcile(); }, 900);
    }
    measure();
    addEventListener('resize', function () { var p = per; measure(); if (p !== per) { reel.scrollTo({ left: offset(cur) }); startSet(true); } });
    reel.addEventListener('scroll', function () {
      lastScroll = performance.now();
      if (auto && !touched) return;
      auto = false; clearTimeout(settle);
      settle = setTimeout(function () {
        var i = at();
        // only a hand swipe restarts the timer; the browser settling the row after an automatic change must not
        if (i !== cur) { cur = i; startSet(true); } else if (touched && !reduce && inView) startSet(false);
        touched = false; align();
      }, 160);
    }, { passive: true });
    reel.addEventListener('pointerdown', function () { touched = true; downAt = performance.now(); clearTimeout(timer); timer = 0; });
    // a tap that does not move the row: carry on with the set it is on
    reel.addEventListener('pointerup', function () {
      setTimeout(function () { if (lastScroll < downAt && inView && !reduce && !timer) { touched = false; startSet(false); } }, 250);
    });
    reel.addEventListener('touchstart', function () { touched = true; }, { passive: true });
    reel.addEventListener('wheel', function () { touched = true; }, { passive: true });
    if (IO) new IntersectionObserver(function (es) {
      es.forEach(function (e) { inView = e.isIntersecting; if (inView) startSet(false); else { clearTimeout(timer); timer = 0; stopAll([]); } });
    }, { threshold: .5 }).observe(reel);
    // reduced motion: tap a video to play or pause it
    if (reduce) cards.forEach(function (c, j) {
      c.classList.add('rm');
      c.addEventListener('click', function () { var v = vids[j]; load(v); if (v.paused) { stopAll([v]); go(v); } else v.pause(); });
    });
    // the rings fill when they come into view; a ring showing "N%" also counts up, anything else (an icon or a figure) fades in
    [].forEach.call(sec.querySelectorAll('.pkws-stat'), function (s) {
      var n = s.querySelector('.pkws-n'), p = +n.getAttribute('data-p') || 100, br = s.querySelector('.br'), pct = !n.hasAttribute('data-fig') && /^\d+%$/.test(n.textContent.trim());
      if (reduce || !IO) { if (pct) n.textContent = p + '%'; if (br) br.style.strokeDashoffset = String(100 - p); return; }
      if (pct) n.textContent = '0%'; else n.style.opacity = '0';
      if (br) br.style.strokeDashoffset = '100';
      new IntersectionObserver(function (es, o) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return; o.disconnect(); if (br) br.style.strokeDashoffset = String(100 - p);
          if (!pct) { n.style.transition = 'opacity .7s ease .4s'; n.style.opacity = '1'; return; }
          var t0 = performance.now();
          (function tick(now) { var k = Math.min(1, (now - t0) / 1300), e2 = 1 - Math.pow(1 - k, 3); n.textContent = Math.round(p * e2) + '%'; if (k < 1) requestAnimationFrame(tick); })(t0);
        });
      }, { threshold: .4 }).observe(s);
    });
  }
  function all() { [].forEach.call(document.querySelectorAll('.pkws'), boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target && e.target.querySelector && e.target.querySelector('.pkws')); });
})();
